export const RDP_LOG_ENTRY_RESOURCE_PATH = '/v2/rdp-logs/entities';
